import merge from 'merge'
import { injectedState } from './injected-state'
import { setCssVar } from '../utils'

export const initialState = {
  hasRendered: false,
  popupDelay: 0,
  isScrolling: false,
  hasShownDelayedPopup: false,
  notifyMeProductHandle: '',
  buttonPaddingTop: 23,
  buttonPaddingBottom: 18,
  formReloadDelay: 2000,
  isWorking: false,
  isWindowLoaded: false,
  shouldShowCartOnAdd: true,
  siteLoaded: false,
  checkout: null,
  shouldShowCart: false,
  shopifyShopOrigin: process.env.GATSBY_SHOPIFY_STORE_URL,
  storefrontAccessToken: process.env.GATSBY_SHOPIFY_STOREFRONT_ACCESS_TOKEN,
  shouldShowFormOverlay: false,
  formOverlayId: '',
  shopifyCdnPathId: '1/0587/3274/0775',
  shouldShowTrainerCardOverlay: false,
  trainerCardId: '',
  containerPaddingX: 25,
  maxContainerWidth: 1440,
  headerMenuHeight: 0,
  grey: '#4A4A4A',
  liteGrey: '#b9b9b9',
  darkGrey: '#1d1d1d',
  isBrowser: typeof window !== 'undefined',
  isTransitioning: false,
  shouldShowNav: false,
  isScrolled: false,
  pageEntryDuration: 0.62,
  pageExitDuration: 0.43,
  headerSlideDuration: 0.25,
  burgerTransformDuration: 0.3,
  fadeTransitionDuration: 1,
  scrollY: 0,
  scrollOffsetY: 10,
  pagePaddingX: 25,
  layoutPaddingY: 25,
  easeOne: 'cubic-bezier(0.87, 0, 0.13, 1)',
  easeOutBack: 'cubic-bezier(0.34, 1.56, 0.64, 1)',
  windowWidth: 0,
  windowHeight: 0,
  pagePaddingTop: 160,
  pagePaddingBottom: 120,
  sectionPaddingBig: 115,
  sectionPaddingSmall: 80,
  formIds: [],
  trainers: [],
  press: [],
  isPortrait: false,
  general: {
    loadMoreProductsText: '',
    variantDefaultTitle: '',
    notifyMeText: '',
    notifyMeFormId: '',
    cartEmptyText: '',
    cartSubtotalText: '',
    cartCheckoutText: '',
    addToCartText: '',
    quantityText: '',
    soldOutText: '',
    comingSoonText: '',
    removeFromCartText: '',
    notifyMeFormName: '',
    defaultPageTitle: '',
    defaultPageDescription: '',
    trackingHeadStart: '',
    trackingHeadEnd: '',
    trackingBodyStart: '',
    trackingBodyEnd: '',
    delayedPopupFormId: '',
  },
  trainerSettings: {
    locationTitleText: '',
    specialtiesTitleText: '',
    quoteTitleText: '',
  },
  header: {
    logo: null,
    cartButtonText: '',
    links: [],
  },
  footer: {
    copyrightText: '',
    privacyButtonText: '',
    policiesButtonText: '',
    termsButtonText: '',
    nyButtonText: '',
    nyFormId: '',
    nyEmail: '',
    laButtonText: '',
    laFormId: '',
    laEmail: '',
    careersButtonText: '',
    socials: [],
  },
  appPage: {
    titleLine1: '',
    titleLine2: '',
    desktopSvg: '',
    mobileSvg: '',
    formId: '',
  },
  balmainPage: {
    hero: {
      dogpoundLogoSvg: '',
      dogpoundLogoUrl: '',
      balmainLogoSvg: '',
      balmainLogoUrl: '',
      desktopImage: '',
      mobileImage1: '',
      mobileImage2: '',
    },
    section1: {
      title: '',
      mobileTitle1: '',
      mobileTitle2: '',
      body: '',
      buttonText: '',
      buttonUrl: '',
      ticker1Svg: '',
      ticker2Svg: '',
      videoEmbedCode: '',
    },
    section2: {
      title: '',
      body: '',
      buttonText: '',
      buttonUrl: '',
      tickerSvg: '',
      sneaker1Image: '',
      sneaker1Url: '',
      sneaker1SoldOutText: '',
      sneaker2Image: '',
      sneaker2Url: '',
      sneaker2SoldOutText: '',
    },
    footer: {
      balmainText: '',
      balmainSiteText: '',
      balmainSiteUrl: '',
      dogpoundText: '',
      dogpoundSiteText: '',
      dogpoundSiteUrl: '',
      instagramText: '',
      instagramUrl: '',
      facebookText: '',
      facebookUrl: '',
      copyrightText: '',
    },
  },
  homePage: {
    hero: {
      title: '',
      backgroundImage: null,
      backgroundVideoUrl: null,
    },
    comingSoon: {
      title: '',
      subtitle: '',
      buttonText: '',
      openInNewTab: '',
      formId: '',
      backgroundImage: null,
      backgroundVideoUrl: '',
    },
    team: {
      title: '',
    },
    joinUs: {
      title: '',
      url: '',
      backgroundImage: null,
    },
  },
  aboutPage: {
    hero: {
      title: '',
      backgroundImage: null,
      backgroundVideoUrl: null,
      scrollToSessionsText: '',
      scrollToClassesText: '',
    },
    servicesSection: {
      title: '',
      subtitle: '',
      services: [],
    },
    gallery: {
      title: '',
      body: '',
      image: [],
    },
    team: {
      title: '',
      moreButtonText: '',
    },
    featured: {
      title: '',
      features: [],
    },
  },
  pressPage: {
    hero: {
      title: '',
      backgroundImage: null,
      backgroundVideoUrl: null,
    },
  },
  smashCityPage: {
    hero: {
      title: '',
      backgroundImage: null,
      backgroundVideoUrl: null,
      descriptionText: '',
      ctaText: '',
      ctaUrl: '',
    },
    intro: {
      title: '',
      description: '',
      image: '',
      ctaText: '',
      ctaUrl: '',
    },
  },
  membershipPage: {
    hero: {
      title: '',
      backgroundImage: null,
      backgroundVideoUrl: null,
      descriptionText: '',
      ctaText: '',
      ctaUrl: '',
    },
    intro: {
      title: '',
      description: '',
      image: '',
      ctaText: '',
      ctaUrl: '',
    },
    overview: {
      title: '',
      description: '',
      tier1Number: '',
      tier1Name: '',
      tier1ButtonText: '',
      tier1ButtonUrl: '',
      tier2Number: '',
      tier2Name: '',
      tier2ButtonText: '',
      tier2ButtonUrl: '',
      rows: [],
    },
    partners: {
      title: '',
      description: '',
    },
    locations: {
      title: '',
      locations1Image: '',
      locations1Hover: '',
      locations1Text: '',
      locations1Url: '',
      locations2Image: '',
      locations2Hover: '',
      locations2Text: '',
      locations2Url: '',
      bottomLinkText: '',
      bottomLinkUrl: '',
    },
    quote: {
      quote: '',
      author: '',
      image: '',
    },
  },
  membershipApplyPage: {
    hero: {
      title: '',
    },
    form: {
      formId: '',
    },
  },
  careersPage: {
    hero: {
      title: '',
      backgroundImage: null,
      backgroundVideoUrl: null,
    },
    listings: [],
  },
  shopPage: {
    hero: {
      title: '',
      subtitleText: '',
      subtitleUrl: '',
      backgroundImage: '',
      backgroundVideoUrl: '',
    },
    featuredCollections: [],
  },
  termsPage: {
    title: '',
    subtitle: '',
    body: '',
  },
  privacyPage: {
    title: '',
    subtitle: '',
    body: '',
  },
  policiesPage: {
    title: '',
    subtitle: '',
    body: '',
  },
}

export const createInitialState = () => {
  const state = merge.recursive(initialState, injectedState)
  setCssVar('buttonPaddingTop', `${state.buttonPaddingTop}px`)
  setCssVar('buttonPaddingBottom', `${state.buttonPaddingBottom}px`)
  setCssVar('fadeTransitionDuration', `${state.fadeTransitionDuration}s`)
  setCssVar('pageEntryDuration', `${state.pageEntryDuration}s`)
  setCssVar('pageExitDuration', `${state.pageExitDuration}s`)
  setCssVar('headerSlideDuration', `${state.headerSlideDuration}s`)
  setCssVar('burgerTransformDuration', `${state.burgerTransformDuration}s`)
  setCssVar('scrollY', `${state.scrollY}px`)
  setCssVar('grey', `${state.grey}`)
  setCssVar('darkGrey', `${state.darkGrey}`)
  setCssVar('liteGrey', `${state.liteGrey}`)
  setCssVar('maxContainerWidth', `${state.maxContainerWidth}px`)
  setCssVar('containerPaddingX', `${state.containerPaddingX}px`)
  setCssVar('headerMenuHeight', `${state.headerMenuHeight}px`)
  setCssVar('pagePaddingX', `${state.pagePaddingX}px`)
  setCssVar('layoutPaddingY', `${state.layoutPaddingY}px`)
  setCssVar('pagePaddingTop', `${state.pagePaddingTop}px`)
  setCssVar('pagePaddingBottom', `${state.pagePaddingBottom}px`)
  setCssVar('sectionPaddingBig', `${state.sectionPaddingBig}px`)
  setCssVar('sectionPaddingSmall', `${state.sectionPaddingSmall}px`)
  setCssVar('windowWidth', `${state.windowWidth}px`)
  setCssVar('windowHeight', `${state.windowHeight}px`)
  setCssVar('easeOne', `${state.easeOne}`)
  setCssVar('easeOutBack', `${state.easeOutBack}`)
  return state
}
